import * as types from './actionTypes';

function getUserMustAcceptTerms() {
  try {
    return JSON.parse(localStorage.getItem('auth/userMustAcceptTerms'));
  } catch (err) {
    return true;
  }
}

const getInitialState = () => ({
  username: localStorage.getItem('auth/username') || '',
  firstName: localStorage.getItem('auth/firstName') || '',
  lastName: localStorage.getItem('auth/lastName') || '',
  isAuthenticated: Boolean(localStorage.getItem('auth/token')),
  refId: localStorage.getItem('auth/refId') || '',
  userMustAcceptTerms: getUserMustAcceptTerms(),
  config: {},
  connectionError: '',
  showWarningDialog: false,
  showLogoutDialog: false,
});

const config = (state = getInitialState(), action) => {
  switch (action.type) {
    case types.UPDATE_CONFIG_SUCCESS: {
      const { config } = action;
      const debugConfig = config ? { ...config } : {};
      // debugConfig.acl = ['/reports/build/debug-path', '/reports/build/legacy'];

      if (config && config.acl) {
        debugConfig.acl.splice(0, 0, ...config.acl);
      }

      if (debugConfig && debugConfig.tiles && debugConfig.length > 0) {
        const tiles = debugConfig.tiles
          ? debugConfig.tiles.map(tile => {
            const tileTemp = tile;
            tileTemp.timeStamp = Date.now();
            return tile;
          })
          : [];

        debugConfig.tiles = tiles;
      }

      return Object.assign({}, state, {
        config: debugConfig
      });
    }

    case types.SET_CURRENT_USER_SUCCESS: {
      return Object.assign({}, state, {
        ...action.userData
      });
    }

    case types.USER_ACCEPT_TERMS_SUCCESS: {
      return Object.assign({}, state, {
        userMustAcceptTerms: false
      });
    }

    case types.FORGOT_PASSWORD_SUCCESS: {
      const { username } = action;
      return Object.assign({}, state, {
        username
      });
    }

    case types.RESET_PASSWORD_SUCCESS: {
      const { email, token, newPassword } = action;
      return Object.assign({}, state, {
        email,
        token,
        newPassword
      });
    }

    case types.VALIDATE_RESET_TOKEN: {
      const { email, token } = action;
      return Object.assign({}, state, {
        email,
        token
      });
    }

    case types.SET_CURRENT_ROLE: {
      const { role } = action;
      return Object.assign({}, state, { role });
    }

    case types.USER_LOGGED_OUT:
      return getInitialState();

    case types.SET_USER_IDLE: {
      const { idle } = action;
      return Object.assign({}, state, { idle });
    }

    case types.SET_DISPLAY_LOGOUT_WARNING_DIALOG: {
      const { showWarningDialog } = action;
      return Object.assign({}, state, { showWarningDialog });
    }

    case types.SET_DISPLAY_LOGOUT_DIALOG: {
      const { showLogoutDialog } = action;
      return Object.assign({}, state, { showLogoutDialog });
    }

    default:
      return state;
  }
};

export default config;



// WEBPACK FOOTER //
// ./src/auth/reducer.js